import {Alert} from "rsuite";

export const Setting = {
    apiUrl: 'https://admin.xitonix.com/',
    apiUrl1: 'https://admin.xitonix.com',
    siteUrl: 'https://web.xitonix.com',
    config: {Accept: "application.json", contentType: "application.json"}
};

export const HandleErorr = (resFromCatch) => {
    let data = resFromCatch['response']['data'];
    let status = resFromCatch['response']['status'];
    if(status === 422) {
        return Object.values(data.errors).forEach(item => Alert.error(`${item}`, 5000));
    }
};
